module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/ja/p10-dc29975c6ea3caec2359395729deabfb.png";